module.exports = __webpack_public_path__ + "img/NukedTV-Web_09.0d5be1d9.png";